// 首字母大写
export function capitalize(str = '') {
  if (!str) {
    return ''
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}
export function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time))
}

// 安卓还是 ios
export function isIOSorAndroid(): string {
  const userAgent = navigator.userAgent.toLowerCase()

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'iOS'
  } else if (/android/.test(userAgent)) {
    return 'Android'
  } else {
    return 'Unknown'
  }
}
// 本地化价格
export function localPriceFormat(value: number): string {
  if (value === undefined || value === null) {
    return ''
  }
  const currency = localStorage.getItem('tapon_currency') || 'USD'
  const locale = localStorage.getItem('tapon_locale') || 'us-US'
  const num = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value / 100)

  return num
}
